import { router } from '@inertiajs/react'
import { useState } from 'react'

export interface ActivityFilters {
  period: string
  from: string | null
  to: string | null
  organization_id: number | null
}

export interface OrgOption {
  id: number
  name: string
}

interface Props {
  path: string
  filters: ActivityFilters
  organizations: OrgOption[]
}

export default function Filters({ path, filters, organizations }: Props) {
  const [customFrom, setCustomFrom] = useState(filters.from ?? '')
  const [customTo, setCustomTo] = useState(filters.to ?? '')

  const apply = (overrides: Partial<Record<string, string>>) => {
    const query: Record<string, string> = {}
    const period = overrides.period ?? filters.period
    query.period = period
    if (period === 'custom') {
      const from = overrides.from ?? customFrom
      const to = overrides.to ?? customTo
      if (from) query.from = from
      if (to) query.to = to
    }
    const org = overrides.organization_id ?? (filters.organization_id ? String(filters.organization_id) : '')
    if (org) query.organization_id = org
    router.get(path, query, { preserveState: true, preserveScroll: true })
  }

  return (
    <div className="flex flex-wrap items-center gap-3 mb-6">
      <div className="flex rounded-lg border border-stone/30 overflow-hidden">
        {['7', '30', '90', 'custom'].map(p => (
          <button
            key={p}
            onClick={() => apply({ period: p })}
            className={`px-3 py-1.5 text-sm font-medium ${
              filters.period === p ? 'bg-[#351E1D] text-white' : 'bg-white text-text-secondary hover:bg-[#F5F5F5]'
            }`}
          >
            {p === 'custom' ? 'Custom' : `${p} days`}
          </button>
        ))}
      </div>

      {filters.period === 'custom' && (
        <div className="flex items-center gap-2 text-sm">
          <input
            type="date"
            value={customFrom}
            onChange={e => setCustomFrom(e.target.value)}
            onBlur={() => apply({})}
            className="border border-stone/30 rounded px-2 py-1.5"
          />
          <span className="text-text-muted">to</span>
          <input
            type="date"
            value={customTo}
            onChange={e => setCustomTo(e.target.value)}
            onBlur={() => apply({})}
            className="border border-stone/30 rounded px-2 py-1.5"
          />
        </div>
      )}

      <select
        value={filters.organization_id ?? ''}
        onChange={e => apply({ organization_id: e.target.value })}
        className="border border-stone/30 rounded-lg px-3 py-1.5 text-sm bg-white"
      >
        <option value="">All organizations</option>
        {organizations.map(o => (
          <option key={o.id} value={o.id}>{o.name}</option>
        ))}
      </select>
    </div>
  )
}
